// extracted by mini-css-extract-plugin
export default {"grid":"Placement_grid__fXelr","t":"Placement_t__G+Hbr","l":"Placement_l__Cspkh","r":"Placement_r__ztMuh","b":"Placement_b__+cyDD","button":"Placement_button__TfUUC"};